// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__3D0AV","box":"WorkspacesBox_box__1K1Ny","node":"WorkspacesBox_node__1Vc8s"};